import { BoostYourRealIcon } from '@/svgs'
import React from 'react'

function BoostYourReal() {
   return (
      <section className="industries-bg-image">
         <div className="container">
            <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-2">
               Boost Your Real Estate Business with Our Custom App Solutions
            </h2>
            <p className="section_desc cs-text-secondary mb-0">
               Our seasoned real estate app developers design custom solutions
               to suit your specific business objectives. From property listings
               to smooth lead management, we provide a complete range of
               cutting-edge features that enable you to remain competitive in
               the fast-evolving real estate market.
            </p>

            <div className="text-center mt-5">
               <BoostYourRealIcon />
            </div>
         </div>
      </section>
   )
}

export default BoostYourReal
